import { ErrorsService } from "src/app/services/common/errors.service";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngstack/translate";

@Component({
  selector: "app-form-errors",
  templateUrl: "./form-errors.component.html",
  styleUrls: ["./form-errors.component.css"]
})
export class FormErrorsComponent implements OnInit {


  constructor(
    public errorService: ErrorsService,
   public translate: TranslateService
  ) {}

  ngOnInit() {
  }
  

}
